import type { ReactNode } from "react";

interface DetailRow {
	label: string;
	value: ReactNode;
	rowClassName?: string;
}

interface ReportErrorDetailsCardProps {
	title: string;
	iconClassName: string;
	rows: DetailRow[];
}

export function ReportErrorDetailsCard({
	title,
	iconClassName,
	rows,
}: ReportErrorDetailsCardProps) {
	return (
		<section className="reportErrorModal__card">
			<div className="reportErrorModal__sectionTitle">
				<span className={iconClassName} aria-hidden />
				<span>{title}</span>
			</div>
			{rows.map((row) => (
				<div
					key={row.label}
					className={`reportErrorModal__detailRow ${
						row.rowClassName ?? ""
					}`.trim()}
				>
					<span className="reportErrorModal__detailLabel">{row.label}:</span>
					<div className="reportErrorModal__detailValue">{row.value}</div>
				</div>
			))}
		</section>
	);
}
